module.exports = __webpack_public_path__ + "media/images/icon/certificate-6ca363ee97e167be6d7e6ddf0d3dc5e0.svg";